module.exports = __webpack_public_path__ + "static/1270066435.6ceea7ee.jpg";